module.exports = __webpack_public_path__ + "static/media/cohesion_heatmap_2.5ce9c841.png";